export default class ThematicGroupService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('thematicGroups/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('thematicGroups', params)
	}

	createEntity(params){
		return this.apiService.callPost('thematicGroups', params);
	}

	updateEntity(id, params){
		return this.apiService.callPut('thematicGroups/'+id, params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('thematicGroups/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ThematicGroupService.js